import { useAuthStore, type UserRole } from "@/store/authStore";
import api from "@/lib/api";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { Button } from "@gradebook/ui";

const roleLabels: Record<UserRole, string> = {
  admin: "Admin",
  teacher: "Teacher",
  student: "Student",
  parent: "Parent",
};

const roleColors: Record<UserRole, string> = {
  admin: "bg-primary-600",
  teacher: "bg-info-600",
  student: "bg-success-600",
  parent: "bg-warning-600",
};

export function ImpersonationBanner() {
  const { impersonation, stopImpersonation } = useAuthStore();

  if (!impersonation?.isImpersonating) {
    return null;
  }

  const handleStopImpersonating = async () => {
    try {
      const response = await api.post("/api/auth/stop-impersonating");
      stopImpersonation(response.data.token);
    } catch (error) {
      console.error("Failed to stop impersonating:", error);
    }
  };

  return (
    <div
      className={`${roleColors[impersonation.effectiveRole]} text-white px-4 py-2 text-sm`}
    >
      <div className="mx-auto max-w-7xl flex items-center justify-between">
        <div className="flex items-center gap-2">
          <span className="font-medium">Viewing as:</span>
          <span className="bg-white/20 px-2 py-0.5 rounded">
            {impersonation.impersonatedUser
              ? `${impersonation.impersonatedUser.firstName} ${impersonation.impersonatedUser.lastName}`
              : roleLabels[impersonation.effectiveRole]}
          </span>
          <span className="text-white/80">
            ({roleLabels[impersonation.effectiveRole]})
          </span>
        </div>
        <Button
          size="sm"
          onClick={handleStopImpersonating}
          className="gap-1 rounded bg-white/20 text-white hover:bg-white/30"
        >
          <XMarkIcon className="size-4" />
          <span>Exit</span>
        </Button>
      </div>
    </div>
  );
}
